/**
 * What counts as an email address, in one place.
 *
 * In `shared` for the reason the password rules are: the API enforces this and
 * the forms explain it, and a form that draws one rule while the server applies
 * another is worse than a form with no rule at all — every field looks accepted
 * and the request is refused anyway.
 *
 * **Loose on purpose, and that is a decision rather than laziness.** Zod's
 * `.email()` and most "correct" patterns reject addresses real mail servers
 * accept — quoted local parts, new top-level domains, plus-addressing in places
 * people genuinely use it. A volunteer whose address the regex dislikes cannot
 * register at all, and there is no appeal: the public form is the only way in.
 * So this asks "does it look like an address", and a human reads it before
 * anybody relies on it.
 *
 * What it does catch is the mistake that actually happens: a name typed into
 * the email box, a missing @, a trailing word, "gmail" with no dot.
 */
/** Something, an @, something, a dot, something — and no spaces anywhere. */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/**
 * The message every form and the API give for a bad address.
 *
 * One string rather than four, because the one thing worse than a validation
 * message is two validation messages for the same rule, phrased differently,
 * depending on which screen you were on.
 */
export const EMAIL_MESSAGE = 'Enter an email address like name@example.com.';
/**
 * Whether this looks like an address.
 *
 * Trims first: a trailing space is the commonest thing to arrive from a paste,
 * and refusing it would be refusing a perfectly good address for a character
 * nobody can see. The API trims before storing for the same reason.
 */
export function isEmailish(value) {
    return EMAIL_PATTERN.test(value.trim());
}
//# sourceMappingURL=email.js.map